import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

interface SuccessModalProps {
  open: boolean;
  onClose: () => void;
  icon: string;
  title: string;
  description: string | React.ReactNode;
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 24px;
  }

  .ant-modal-body {
    text-align: center;
    padding: 40px 24px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;

  img {
    width: 62px;
    height: 62px;
  }
`;

const Title = styled.h3`
  font-family: Inter;
  font-weight: 700;
  font-size: 20px;
  color: #1F2937;
  margin: 0 0 16px 0;
`;

const Description = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-size: 16px;
  color: #6B7280;
  line-height: 1.6;
  margin: 0;
`;

const SuccessModal: React.FC<SuccessModalProps> = ({ open, onClose, icon, title, description }) => {
  return (
    <StyledModal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable={true}
      width={450}
    >
      <IconWrapper>
        <img src={icon} alt={title} />
      </IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </StyledModal>
  );
};

export default SuccessModal;

